import React from 'react';
import PropTypes from 'prop-types';
import NwfBox from './NwfBox';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const WordRow = props => {
    const { wordItems } = props;
    return (
        <div className="row phoneme-row">
            <div className="col-12">
                {wordItems.map((wordItem, index) => (
                    <NwfBox key={generateReactKey(index, wordItem.word)} wordItem={wordItem} />
                ))}
            </div>
        </div>
    );
};

WordRow.defaultProps = {
    wordItems: [],
};

WordRow.propTypes = {
    wordItems: PropTypes.array,
};

export default WordRow;
